<div class="modal-container">
  <button
    id="modalTerminos"
    #modalTerminos
    data-bs-toggle="modal"
    data-bs-target="#modalTerminosCondiciones"
    hidden="hidden"
    hidden
    aria-hidden="true"
    tabindex="-1">
    Launch
  </button>
  <div
    class="modal fade"
    id="modalTerminosCondiciones"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="modalTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title h5-tipografia-govco" *ngIf="titulo">{{ titulo }}</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            (click)="onRechazar()"
            aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="content-wrapper">
            <div [innerHTML]="contenido"></div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn-govco outline-btn-govco"
            data-bs-dismiss="modal"
            (click)="onRechazar()"
            aria-label="Rechazar">
            Rechazar
          </button>
          <button
            type="button"
            class="btn-govco fill-btn-govco"
            data-bs-dismiss="modal"
            (click)="onAceptar()"
            aria-label="Aceptar">
            Aceptar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
